(function () {
  const $ = id => document.getElementById(id);
  const money = cents => '$' + (cents / 100).toFixed(2);

  const COLOR_SWATCHES = { Black: '#1A1A1A', White: '#F4F4F4', Red: '#E42313', Blue: '#1D4FD7', Yellow: '#F2D410', Green: '#2E9E44' };

  // Give each color swatch button its background color (was inline Liquid/JS dict lookup before)
  document.querySelectorAll('.color-btn').forEach(btn => {
    const c = btn.dataset.value;
    btn.style.setProperty('--sw', COLOR_SWATCHES[c] || '#888');
  });

  // ---------- Variant resolution ----------
  // Reads the real Shopify variants embedded per-card and finds the one matching
  // whichever size/color buttons are currently active.
  function getVariants(card) {
    const script = card.querySelector('.variant-json');
    if (!script) return [];
    if (!card._variants) card._variants = JSON.parse(script.textContent);
    return card._variants;
  }

  function getSelectedVariant(card) {
    const variants = getVariants(card);
    if (!variants.length) return null;
    const selected = {};
    card.querySelectorAll('.size-btn.active, .color-btn.active').forEach(btn => {
      selected[btn.dataset.optionIndex] = btn.dataset.value;
    });
    const match = variants.find(v =>
      Object.entries(selected).every(([idx, val]) => v['option' + idx] === val)
    );
    return match || variants[0];
  }

  // Updates price, image, and add-to-cart availability for a card after a size/color change
  function updateCardForSelection(card) {
    const variant = getSelectedVariant(card);
    if (!variant) return;

    const priceEl = card.querySelector('.price');
    if (priceEl) priceEl.textContent = money(variant.price);

    const addBtn = card.querySelector('.add-btn');
    if (addBtn) {
      const soldOut = variant.available === false;
      addBtn.disabled = soldOut;
      addBtn.textContent = soldOut ? 'Sold out' : 'Add to cart';
    }

    const mainPhoto = card.querySelector('.main-photo');
    if (!mainPhoto) return;

    if (variant.featured_image && variant.featured_image.src) {
      mainPhoto.src = variant.featured_image.src;
      return;
    }

    // No dedicated photo for this variant — if a color is selected, recolor the base photo instead
    const activeColor = card.querySelector('.color-btn.active');
    const baseImage = card.querySelector('.card-media').dataset.baseImage;
    if (activeColor && baseImage && COLOR_SWATCHES[activeColor.dataset.value]) {
      recolor(baseImage, activeColor.dataset.value).then(url => { mainPhoto.src = url; });
    } else if (baseImage) {
      mainPhoto.src = baseImage;
    }
  }

  // ---------- Cart (real Shopify cart via AJAX) ----------

  // Updates the free shipping progress bar in the cart drawer based on the current cart total.
  // Expects markup with id="freeShippingBar" (with a data-threshold attribute in cents),
  // id="freeShippingProgress" (the fill element), and id="freeShippingMessage" (the copy).
  // No-ops safely if that markup isn't present on the page.
  function updateFreeShippingBar(cartData) {
    const bar = $('freeShippingBar');
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold, 10);
    const progressEl = $('freeShippingProgress');
    const messageEl = $('freeShippingMessage');
    if (!threshold || !progressEl || !messageEl) return;

    const current = cartData.total_price;
    const remaining = Math.max(threshold - current, 0);
    const progress = Math.min((current / threshold) * 100, 100);

    progressEl.style.width = progress + '%';

    messageEl.innerHTML = remaining > 0
      ? `You are only <strong>${money(remaining)}</strong> away from free shipping!`
      : `🎉 Congrats! You've unlocked free shipping!`;
  }

  function renderCartFromData(cartData) {
    $('cartCount').textContent = cartData.item_count;
    const box = $('drawerItems');
    if (cartData.items.length === 0) {
      box.innerHTML = '<p class="empty">Your cart is empty.<br>Green flag is out — go shopping.</p>';
    } else {
      box.innerHTML = cartData.items.map(item => `
        <div class="line-item">
          <div class="thumb">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
          <div class="info"><strong>${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''}</strong><span>${money(item.price)} each</span></div>
          <div class="qty">
            <button data-dec="${item.key}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button data-inc="${item.key}" aria-label="Increase quantity">+</button>
          </div>
        </div>`).join('');
    }
    $('subtotal').textContent = money(cartData.total_price);
    $('checkoutBtn').disabled = cartData.item_count === 0;

    updateUpsellVisibility(cartData);
    updateFreeShippingBar(cartData);

    return cartData;
  }

  function refreshCart() {
    return fetch('/cart.js').then(r => r.json()).then(renderCartFromData);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    }).then(r => {
      if (!r.ok) return r.json().then(err => Promise.reject(err));
      return r.json();
    }).then(refreshCart);
  }

  // ---------- Cart upsell ----------
  function getUpsellVariants() {
    const script = $('CartUpsellVariants');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      console.error('Could not parse cart upsell variants:', err);
      return [];
    }
  }

  function getSelectedUpsellVariant() {
    const upsell = $('cartUpsell');
    if (!upsell) return null;

    const variants = getUpsellVariants();
    if (!variants.length) return null;

    const selects = upsell.querySelectorAll('.cart-upsell__select');

    if (!selects.length) {
      return variants.find(variant => variant.available) || variants[0] || null;
    }

    const selectedOptions = [];

    selects.forEach(select => {
      selectedOptions[Number(select.dataset.optionIndex)] = select.value;
    });

    return variants.find(variant => {
      const variantOptions = [
        variant.option1,
        variant.option2,
        variant.option3
      ];

      return selectedOptions.every((value, index) => {
        return variantOptions[index] === value;
      });
    }) || null;
  }

  function updateUpsellVariant() {
    const upsell = $('cartUpsell');
    const addBtn = $('CartUpsellAdd');

    if (!upsell || !addBtn) return;

    const variant = getSelectedUpsellVariant();

    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      delete addBtn.dataset.variantId;
      return;
    }

    addBtn.dataset.variantId = variant.id;

    const price = $('CartUpsellPrice');
    if (price) {
      price.textContent = money(variant.price);
    }

    const image = $('CartUpsellImage');
    if (image && variant.featured_image && variant.featured_image.src) {
      image.src = variant.featured_image.src;
    }

    if (variant.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
    }
  }

  function updateUpsellVisibility(cartData) {
    const upsell = $('cartUpsell');
    if (!upsell) return;

    const upsellProductId = String(upsell.dataset.productId);

    const alreadyInCart = cartData.items.some(item => {
      return String(item.product_id) === upsellProductId;
    });

    upsell.hidden = alreadyInCart;

    if (!alreadyInCart) {
      updateUpsellVariant();
    }
  }

  function changeQty(key, delta) {
    const btn = document.querySelector(`[data-inc="${key}"], [data-dec="${key}"]`);
    const row = btn ? btn.closest('.line-item') : null;
    const currentQty = row ? parseInt(row.querySelector('.qty span').textContent, 10) : 0;
    const newQty = Math.max(0, currentQty + delta);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(r => r.json()).then(renderCartFromData);
  }

  function openDrawer() {
    const drawer = $('drawer');
    const overlay = $('overlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }

  function closeDrawer() {
    const drawer = $('drawer');
    const overlay = $('overlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  // Shared cart helpers used by product templates.
  window.addToCart = addToCart;
  window.openDrawer = openDrawer;

  // Populate the real Shopify cart immediately on every template.
  if ($('drawerItems') && $('cartCount') && $('subtotal') && $('checkoutBtn')) {
    refreshCart().catch(err => console.error('Could not refresh cart:', err));
  }

  function openNavDrawer() {
    const navDrawer = $('navDrawer');
    const navOverlay = $('navOverlay');
    if (navDrawer) navDrawer.classList.add('open');
    if (navOverlay) navOverlay.classList.add('open');
  }

  function closeNavDrawer() {
    const navDrawer = $('navDrawer');
    const navOverlay = $('navOverlay');
    if (navDrawer) navDrawer.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
  }

  document.addEventListener('change', e => {
    if (e.target.matches('.cart-upsell__select')) {
      updateUpsellVariant();
    }
  });

  document.addEventListener('click', e => {
    const upsellAdd = e.target.closest('[data-upsell-add], #CartUpsellAdd');

    if (upsellAdd && !upsellAdd.disabled) {
      const variantId = upsellAdd.dataset.variantId;
      if (!variantId) return;

      upsellAdd.disabled = true;
      upsellAdd.textContent = 'Adding...';

      addToCart(variantId, 1)
        .catch(err => {
          console.error('Could not add upsell:', err);
          upsellAdd.disabled = false;
          upsellAdd.textContent = (err && err.description) || 'Add to cart';
        });

      return;
    }

    const photo = e.target.closest('.main-photo');
    if (photo) {
      const card = photo.closest('.card');
      const activeColor = card.querySelector('.color-btn.active');
      const variant = getSelectedVariant(card);
      let imgs, color = null, start = 0;
      if (activeColor && variant && variant.featured_image && variant.featured_image.src) {
        // This variant has its own real photo — show just that, not the general gallery
        imgs = [variant.featured_image.src];
      } else {
        const thumbs = [...card.querySelectorAll('.thumb-btn')].map(b => b.dataset.full);
        imgs = thumbs.length ? thumbs : [photo.src];
        start = imgs.indexOf(photo.src);
        start = start >= 0 ? start : 0;
        if (activeColor) color = activeColor.dataset.value;
      }
      openLightbox(imgs, start, color);
      return;
    }

    const thumb = e.target.closest('.thumb-btn');
    if (thumb) {
      const card = thumb.closest('.card');
      card.querySelector('.main-photo').src = thumb.dataset.full;
      card.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
      thumb.classList.add('active');
      return;
    }

    const sizeBtn = e.target.closest('.size-btn');
    if (sizeBtn) {
      sizeBtn.closest('.sizes').querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      sizeBtn.classList.add('active');
      updateCardForSelection(sizeBtn.closest('.card'));
      return;
    }

    const colorBtn = e.target.closest('.color-btn');
    if (colorBtn) {
      colorBtn.closest('.colors').querySelectorAll('.color-btn').forEach(b => b.classList.remove('active'));
      colorBtn.classList.add('active');
      updateCardForSelection(colorBtn.closest('.card'));
      return;
    }

    const add = e.target.closest('.add-btn');
    if (add && !add.disabled) {
      const card = add.closest('.card');
      const variant = getSelectedVariant(card);
      if (!variant || variant.available === false) return;
      add.disabled = true;
      addToCart(variant.id, 1).then(() => {
        add.textContent = 'Added ✓'; add.classList.add('added');
        setTimeout(() => { add.textContent = 'Add to cart'; add.classList.remove('added'); add.disabled = false; }, 900);
        openDrawer();
      }).catch(err => {
        console.error(err);
        add.disabled = false;
        alert((err && err.description) || 'Could not add this item to your cart. Please try again.');
      });
      return;
    }

    if (e.target.dataset.inc) changeQty(e.target.dataset.inc, 1);
    if (e.target.dataset.dec) changeQty(e.target.dataset.dec, -1);
  });

  const openCartBtn = $('openCart');
  const closeCartBtn = $('closeCart');
  const cartOverlay = $('overlay');
  const checkoutBtn = $('checkoutBtn');

  if (openCartBtn) openCartBtn.addEventListener('click', openDrawer);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeDrawer);
  if (checkoutBtn) checkoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });

  // ---------- Mobile nav drawer ----------
  const hamburger = document.querySelector('.hamburger');
  const closeNavBtn = $('closeNav');
  const navOverlay = $('navOverlay');
  const navDrawer = $('navDrawer');

  if (hamburger) hamburger.addEventListener('click', openNavDrawer);
  if (closeNavBtn) closeNavBtn.addEventListener('click', closeNavDrawer);
  if (navOverlay) navOverlay.addEventListener('click', closeNavDrawer);

  if (navDrawer) {
    navDrawer.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector(link.getAttribute('href'));
        closeNavDrawer();
        if (target) {
          setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
        }
      });
    });
  }

  // ---------- Lightbox ----------
  // Recolors red plastic in a photo to the chosen color, in the browser, with caching.
  // Used whenever a variant doesn't have its own photographed image.
  const COLOR_ADJ = { Blue: [240, 1.00, 0.80], Yellow: [57, 0.95, 1.35], Green: [120, 0.92, 0.95], Black: [0, 0.06, 0.30] };
  const recolorCache = new Map();
  function recolor(src, color) {
    if (!COLOR_ADJ[color]) return Promise.resolve(src);
    const key = color + ':' + src.length + ':' + src.slice(100, 160);
    if (recolorCache.has(key)) return Promise.resolve(recolorCache.get(key));
    return new Promise(resolve => {
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = () => {
        const c = document.createElement('canvas');
        c.width = im.width; c.height = im.height;
        const ctx = c.getContext('2d');
        ctx.drawImage(im, 0, 0);
        const d = ctx.getImageData(0, 0, c.width, c.height);
        const [th, sm, vm] = COLOR_ADJ[color];
        const px = d.data;
        for (let i = 0; i < px.length; i += 4) {
          const r = px[i] / 255, g = px[i + 1] / 255, b = px[i + 2] / 255;
          const max = Math.max(r, g, b), min = Math.min(r, g, b), v = max, dlt = max - min;
          const s = max ? dlt / max : 0;
          if (dlt === 0) continue;
          let h;
          if (max === r) h = ((g - b) / dlt) % 6;
          else if (max === g) h = (b - r) / dlt + 2;
          else h = (r - g) / dlt + 4;
          h *= 60; if (h < 0) h += 360;
          const d2 = Math.min(h, 360 - h);
          const wh = Math.max(0, Math.min(1, 1 - Math.max(0, d2 - 22.5) / 22.5));
          const ws = Math.max(0, Math.min(1, (s - 0.157) / 0.216));
          const wv = Math.max(0, Math.min(1, (v - 0.118) / 0.137));
          const w = wh * ws * wv;
          if (w <= 0) continue;
          const ns = Math.min(1, s * sm), nv = Math.min(1, v * vm);
          const cc = nv * ns, x = cc * (1 - Math.abs(((th / 60) % 2) - 1)), m = nv - cc;
          let rr, gg, bb;
          if (th < 60) { rr = cc; gg = x; bb = 0; }
          else if (th < 120) { rr = x; gg = cc; bb = 0; }
          else if (th < 180) { rr = 0; gg = cc; bb = x; }
          else if (th < 240) { rr = 0; gg = x; bb = cc; }
          else if (th < 300) { rr = x; gg = 0; bb = cc; }
          else { rr = cc; gg = 0; bb = x; }
          px[i] = px[i] * (1 - w) + (rr + m) * 255 * w;
          px[i + 1] = px[i + 1] * (1 - w) + (gg + m) * 255 * w;
          px[i + 2] = px[i + 2] * (1 - w) + (bb + m) * 255 * w;
        }
        ctx.putImageData(d, 0, 0);
        const url = c.toDataURL('image/jpeg', 0.92);
        recolorCache.set(key, url);
        resolve(url);
      };
      im.src = src;
    });
  }

  let lbImgs = [], lbIndex = 0, lbColor = null, lbTicket = 0;
  const lb = $('lightbox');
  function lbShow() {
    const src = lbImgs[lbIndex];
    const ticket = ++lbTicket;
    if (lbColor) {
      recolor(src, lbColor).then(url => { if (ticket === lbTicket) $('lbImg').src = url; });
    } else {
      $('lbImg').src = src;
    }
  }
  function openLightbox(imgs, start, color) {
    lbImgs = imgs; lbIndex = start >= 0 ? start : 0; lbColor = color || null;
    lbShow();
    lb.classList.add('open');
    lb.classList.toggle('multi', lbImgs.length > 1);
  }
  function lbStep(d) {
    lbIndex = (lbIndex + d + lbImgs.length) % lbImgs.length;
    lbShow();
  }
  const lbClose = $('lbClose');
  const lbPrev = $('lbPrev');
  const lbNext = $('lbNext');

  if (lbClose && lb) lbClose.addEventListener('click', () => lb.classList.remove('open'));
  if (lbPrev && lb) lbPrev.addEventListener('click', e => { e.stopPropagation(); lbStep(-1); });
  if (lbNext && lb) lbNext.addEventListener('click', e => { e.stopPropagation(); lbStep(1); });
  if (lb) lb.addEventListener('click', e => { if (e.target === lb) lb.classList.remove('open'); });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeDrawer();
      closeNavDrawer();
      if (lb) lb.classList.remove('open');
    }
    if (lb && lb.classList.contains('open')) {
      if (e.key === 'ArrowLeft') lbStep(-1);
      if (e.key === 'ArrowRight') lbStep(1);
    }
  });

  // ---------- Custom project form ----------
  let cfFileList = [];
  const cfDrop = $('cfDrop');
  const cfFiles = $('cfFiles');
  const cfPreviews = $('cfPreviews');
  const customCta = $('customCta');
  const customForm = $('customForm');

  function cfRender() {
    if (!cfPreviews) return;
    cfPreviews.innerHTML = cfFileList.map((f, i) => `
      <div class="cf-thumb">
        ${f.url ? `<img src="${f.url}" alt="">` : `<span class="cf-file">${f.name}</span>`}
        <button type="button" data-rm="${i}" aria-label="Remove file">×</button>
      </div>`).join('');
  }

  function cfAdd(files) {
    for (const f of files) {
      const entry = { name: f.name, url: null };
      if (f.type.startsWith('image/')) entry.url = URL.createObjectURL(f);
      cfFileList.push(entry);
    }
    cfRender();
  }

  if (cfDrop && cfFiles) {
    cfDrop.addEventListener('click', () => cfFiles.click());
    cfFiles.addEventListener('change', e => {
      cfAdd(e.target.files);
      e.target.value = '';
    });
    cfDrop.addEventListener('dragover', e => {
      e.preventDefault();
      cfDrop.classList.add('over');
    });
    cfDrop.addEventListener('dragleave', () => cfDrop.classList.remove('over'));
    cfDrop.addEventListener('drop', e => {
      e.preventDefault();
      cfDrop.classList.remove('over');
      cfAdd(e.dataTransfer.files);
    });
  }

  if (cfPreviews) {
    cfPreviews.addEventListener('click', e => {
      const rm = e.target.closest('[data-rm]');
      if (rm) {
        cfFileList.splice(Number(rm.dataset.rm), 1);
        cfRender();
      }
    });
  }

  if (customCta && customForm) {
    customCta.addEventListener('click', e => {
      e.preventDefault();
      customForm.classList.add('open');
      const cfName = $('cfName');
      if (cfName) cfName.focus();
      customForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    customForm.addEventListener('submit', e => {
      e.preventDefault();

      const email = $('cfEmail');
      if (!email) return;

      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
      email.classList.toggle('error', !valid);
      if (!valid) {
        email.focus();
        return;
      }

      const cfName = $('cfName');
      const cfPhone = $('cfPhone');
      const cfDesc = $('cfDesc');

      const body = [
        'Name: ' + (cfName ? cfName.value : ''),
        'Email: ' + email.value,
        'Phone: ' + (cfPhone ? cfPhone.value : ''),
        '',
        'Project details:',
        cfDesc ? cfDesc.value : '',
        '',
        cfFileList.length
          ? 'Files to attach (please attach these before sending):\n' + cfFileList.map(f => '  - ' + f.name).join('\n')
          : "(Don't forget to attach your sketch or photo!)"
      ].join('\n');

      window.location.href = 'mailto:bruce@silver-ventures.com?subject='
        + encodeURIComponent('Custom Project Request — ' + ((cfName && cfName.value) || 'New inquiry'))
        + '&body=' + encodeURIComponent(body);

      const customDone = $('customDone');
      if (customDone) customDone.classList.add('show');
    });
  }

  // ---------- Signup ----------
  const signupForm = $('signupForm');

  if (signupForm) {
    signupForm.addEventListener('submit', e => {
      e.preventDefault();

      const email = $('suEmail');
      if (!email) return;

      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
      email.classList.toggle('error', !valid);
      if (!valid) {
        email.focus();
        return;
      }

      // Demo only: connect this form to your email provider
      // (Shopify captures signups natively; Mailchimp/Klaviyo also work)
      signupForm.style.display = 'none';

      const signupDone = $('signupDone');
      if (signupDone) signupDone.classList.add('show');
    });
  }

})();
